import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";

export const GetAllData = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.NGSLis.ResultData.GetAll}`,
    queryModel
  );
};

export const ExportToExcel = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.NGSLis.ResultData.ExportToExcel}`,
    queryModel
  );
};

export const Archive = (queryModel: number[]) => {
  return HttpClient().post(
    `/${apiRoutes.NGSLis.ResultData.Archive}`,
    queryModel
  );
};

export const Restore = (queryModel: number[]) => {
  return HttpClient().post(
    `/${apiRoutes.NGSLis.ResultData.Restore}`,
    queryModel
  );
};

export const Rejected = (queryModel: number[]) => {
  return HttpClient().post(
    `/${apiRoutes.NGSLis.ResultData.Rejected}`,
    queryModel
  );
};

export const BulkPublishAndValidate = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.NGSLis.ResultData.BulkPublishAndValidate}`,
    queryModel
  );
};

export const UnPublishAndUnValidate = (queryModel: number[]) => {
  return HttpClient().post(
    `/${apiRoutes.NGSLis.ResultData.UnPublishAndUnValidate}`,
    queryModel
  );
};
